module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "ec23f5702ae68_001.0725a639.png";